/** Persistent defender state (Firestore `users/{uid}/private/homeDefense`). */
export type HomeStructureDefenseState = {
  damageTaken: number;
  lastDamageAt: number;
  brokenUntil: number;
};

export type HomeStructureCardCounts = {
  hpCards: number;
  defCards: number;
  regenCards: number;
};

export type HomeStructurePotionSettings = {
  potions: number;
  autoEnabled: boolean;
  autoHpPercent: number;
};

export type HomeStructureCombatSnapshot = {
  maxHp: number;
  defense: number;
  regenPerSec: number;
  damageTaken: number;
  currentHp: number;
  brokenUntil: number;
  shieldActive: boolean;
  canBeAttacked: boolean;
  solidPlacementId: string | null;
};

export const HOME_STRUCTURE_HP_CARD_SKU = "home.structure_hp_card.v1";
export const HOME_STRUCTURE_DEF_CARD_SKU = "home.structure_def_card.v1";
export const HOME_STRUCTURE_REGEN_CARD_SKU = "home.structure_regen_card.v1";
export const HOME_STRUCTURE_HP_POTION_SKU = "home.structure_hp_potion.v1";

export const HOME_STRUCTURE_HP_CARD_CASH_COST = 10;
export const HOME_STRUCTURE_DEF_CARD_CASH_COST = 10;
export const HOME_STRUCTURE_REGEN_CARD_CASH_COST = 10;
